export default function intercomReducer(intercom, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "exten":
      return { ...intercom, [action.type]: action.value ? Number(action.value).toString() : "" };

    case "addMember":
      return { ...intercom, members: [...intercom.members, action.member] };
    case "removeMember":
      return {
        ...intercom,
        members: intercom.members.filter((intercomMember) => intercomMember.id !== action.sippeerId),
      };

    default:
      return { ...intercom, [action.type]: action.value };
  }
}
